/*
 * @Author: CYX
 * @Date: 2020-07-10 14:56:31
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 15:32:53
 */ 
export const AddressBookEn = {
    address: "Address book",
    namePehop: "Please enter consignee name/contact information",
    shousuo: "search",
    ADDaddress: "New receiving address",
    shouhuoren: "consignee",
    szaddress: "location ",
    szaddress1: "location ：",
    jdaddress: "street address",
    lianxidianhua: "contact number",
    sheweimr: "Set to the default",
    shrxxdz: "Please enter the company name",
    qsrshrsjhm: "Please enter the consignee's mobile phone number",
    qxzgsmc: "Please select the company name",
    qsrzqdsjhm: "Please enter the correct cell phone number",
    qsrsjhm: "Please enter your mobile phone number",
    qsrzqdyx: "Please enter the correct email address"
}


// WEBPACK FOOTER //
// ./src/lang/member/AddressBook/indexEn.js